<template>
  <div class="call-order" :data-scb-form="`scb-${pageId}`">
    <a href="tel:+74957800500" :class="`call-order__phone ${calltrackClass}`">+7 (495) 7-800-500</a>
    <form v-if="!isSuccess" @submit.prevent="orderCall">
      <h3 class="call-order__title">Заказать <br>обратный звонок</h3>
      <div class="call-order__field" :class="{ 'error': $v.name.$error }">
        <div class="input">
          <input type="text" placeholder="Имя*" v-model.trim="name">
        </div>
        <div class="error" v-if="!$v.name.isCorrect">Только русские буквы</div>
        <div class="error" v-if="!$v.name.required">Обязательное поле</div>
      </div>
      <div class="call-order__field" :class="{ 'error': $v.phone.$error }">
        <div class="input">
            <input
                v-if="!isFirefox"
                type="tel"
                inputmode="tel"
                v-model="phone"
                id="call-order-phone"
                v-mask="'phone'"
                @input="$v.phone.$touch()"
                @change="modalTouch"
                autocomplete="tel"
                ref="call-order-phone"
                :disabled="disabledMaskInputs"
                data-scb-form-type="scb-form-phone-field"
                :data-scb-form-field="`scb-${pageId}-input-phone`"
                placeholder="Номер телефона*"
            />
           <masked-input v-else type="text" mask="\+\7 111 111 11 11" placeholder="Номер телефона*" v-model="phone" />
        </div>
        <div class="error" v-if="!$v.phone.required">Обязательное поле</div>
        <div class="error" v-if="!$v.phone.isCorrect">Некорректный номер</div>
      </div>
      <div class="checkbox" :class="{ 'error': $v.conditions.$error }">
        <input type="checkbox" id="conditions-side" v-model="conditions" >
        <label for="conditions-side"><span class="checkbox-icon"></span><span>Я согласен с условиями <a href="/document_politics.php" target="_blank">Политики обработки персональных данных</a> и даю <a href="/document.php?element=103802152" target="_blank">Согласие на обработку моих персональных данных</a></span></label>
        <div class="error" v-if="!$v.conditions.sameAs">Обязательное поле</div>
      </div>
      <input
          class="button button_dark"
          type="submit"
          value="Вызвать скорую"
          data-scb-form-type="scb-form-submit"
          :data-scb-form-field="`scb-${pageId}-button-submit`"
      />
      <!-- <div class="agreement_and_docs">
        <div class="agreement_and_docs_text">
          * Нажимая кнопку «Вызвать скорую», вы соглашаетесь с обработкой своих персональных данных АО «Группа компаний «МЕДСИ»
        </div>
        <div class="agreement_and_docs_docs">
          <div>
            <a class="agreement_and_docs_links" target="_blank" href="/document_politics.php">Политика в отношении обработки персональных данных</a>
          </div>
          <div>
             <a class="agreement_and_docs_links" target="_blank" href="/document_agreement.php">Согласие на обработку персональных данных</a>
          </div>
        </div>
      </div> -->
    </form>
        <div v-else>
            <div class="call-order__title">Ваша заявка принята</div>
            <div class="call-order__content" v-html="ctaSuccessMessage" />
            <button v-if="!$root.popup.call" class="button button_light" @click="isSuccess = false">Назад</button>
        </div>
    </div>
</template>

<script>
import {required, minLength, sameAs} from 'vuelidate/lib/validators';
import scrollToWithAnimation from 'scrollto-with-animation';
import axios from 'axios';
import MaskedInput from 'vue-masked-input';

export default {
    name: 'CallOrder',
    props: {
        page: {
            type: String,
            default: '',
        },
        pageId: {
            type: String,
            default: '',
        },
        section: {
            type: String,
            default: '',
        },
        ctaSuccessMessage: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            name: '',
            phone: '',
            conditions: false,
            isSuccess: false,
            disabledMaskInputs: true,
            calltrackClass: window.GLOBAL_CALLTRACK_CLASS || '',
            isFirefox: navigator.userAgent.toLowerCase().includes('firefox')
        }
    },
    validations: {
        name: {
            required,
            isCorrect: (param) => {
                return param ? /^[А-Яа-яЁё\-' ]+$/.test(param) : true;
            },
        },
        phone: {
            required,
            minLength: minLength(16),
            isCorrect: (param) => {
                return param ? !/_/.test(param) : true;
            },
        },
        conditions: {
            sameAs: sameAs(() => true),
        },
    },
    mounted() {
        // хак ie11, чтобы избежать автофокуса в инпут с маской при загрузке страницы
        setTimeout(() => {
            this.disabledMaskInputs = false;
        }, 250);
    },
    methods: {
        modalTouch(e) {
            if(this.phone == '') {
                this.phone = e.target.value;
            }
        },
        orderCall() {
            const vm = this;
            this.$v.$touch();
            if (!this.$v.$anyError) {
                /**
                 * send ajax
                 * method post
                 * @type {string}
                 */
                let action = '/local/components/ux/calltoaction_229/ajax.php';
                let data = {
                    WEB_FORM_ID: 7,
                    name: this.name,
                    phone: this.phone,
                    page: this.page,
                    section: this.section,
                };

                let formData = new FormData();
                Object.keys(data).forEach(key => formData.append(key, data[key]));

                axios.post(action, formData)
                    .then(function (res) {
                        if (!res.data.error) {
                            vm.isSuccess = true;
                            vm.name = '';
                            vm.phone = '';
                            vm.$v.$reset();
                            if (document.getElementById('call')) {
                                let formTop = document.getElementById('call').getBoundingClientRect().top + document.documentElement.scrollTop - 60;
                                scrollToWithAnimation(document.documentElement, 'scrollTop', formTop, 300, 'easeInOutSine');
                            }
                            setTimeout(function () {
                                vm.$root.popup.call = false;
                            }, 5000);
                        } else {
                            alert(res.data.error);
                        }
                    })
                    .catch(function (err) {
                        console.log(err);
                        vm.$root.popup.call = false;
                    });
            }
        },
    },
    components: {
      MaskedInput
    }
}
</script>
<style lang="scss">
@import "../../scss/base/include";

.call-order {
    height: 100%;
    border: 1px solid rgba(0, 171, 170, 0.4);
    position: relative;
    border-radius: 20px;
    padding: 59px 27px 33px 27px;
    background-color: $white-true;
    @include tablet {
        padding: 59px 32px 33px 32px;
    }
    @include mobile {
        padding: 59px 22px 44px 22px;
    }

    &__phone {
        position: absolute;
        background: #5BC6C1;
        color: $white-true;
        border-radius: 20px 5px;
        padding: 10px 35px;
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        top: -1px;
        left: -1px;
    }

    &__title {
        font-weight: 500;
        font-size: 24px;
        line-height: 30px;
        margin: 0 0 14px;
        @include tablet {
            font-weight: bold;
            font-size: 18px;
            line-height: 22px;
            margin: 0 0 19px;
        }
    }
    &__content {
        margin-bottom: 20px;
    }

    &__field {
        margin-bottom: 10px;

        .input {
            width: 100%;
            height: 40px;
            background: rgba(234, 234, 234, 0.5);
            border-radius: 7px;
            padding: 0 19px;
        }

        input {
            padding: 0;
            width: 100%;
            height: 100%;
            border: none;
            outline: none;
        }

        &.error {
            .error {
                display: block;
            }
        }

        .error {
            display: none;
            color: rgba(255, 0, 0, 0.8);
            font-size: 14px;
        }
    }

    .checkbox {
        margin-top: 20px;
        margin-bottom: 15px;

        &.error {
            .error {
                display: block;
            }
        }

        .error {
            display: none;
            color: rgba(255, 0, 0, 0.8);
            font-size: 14px;
        }

        input {
            &:checked {
                & + label {
                    .checkbox-icon {
                        background-size: 15.2px;
                    }
                }
            }
        }

        label {
            max-width: 420px;
            font-size: 12px;
            line-height: 17px;
            color: $gray;
            padding: 0 0 3px 34px;
            pointer-events: none;
            @include tablet {
                padding: 0 0 0 34px;
            }
            @include mobile {
                min-height: 34px;
            }

            a {
                text-decoration: underline;
                pointer-events: auto;
                &:hover {
                    color: #00ABAA;
                }
            }
        }

        &-icon {
            width: 24px;
            height: 24.8px;
            background: $border2;
            top: 2px;
            pointer-events: auto;
            @include tablet {
                top: 2px;
            }
        }
    }

    .button {
        padding: 0 20px;
        width: 100%;
        @include tablet {
            height: 50px;
            width: 226px;
        }
    }
}
.agreement_and_docs {
  margin-top: 20px;
  font-size: 12px;
}
.agreement_and_docs_text {
  color: #7d7987;
}

.agreement_and_docs_docs {
  margin-top: 5px;
}

// .agreement_and_docs_links {
//   color: #00ABAA;
//   text-decoration: underline;
// }

// .agreement_and_docs_links:hover {
//   color: #03C2C1;
//   text-decoration: underline;
// }
</style>
